import {
  color,
  ColorProps,
  compose,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  ResponsiveStyleValue,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { transition, TransitionProps } from '../../transition'
import { whiteSpace, WhiteSpaceProps } from '../typography'
import { Button, ButtonProps } from './Button'
import {
  buttonDisabledVariants,
  ButtonLayoutProps,
  buttonLayoutVariant,
  buttonLoadingVariants,
  buttonStateMapping,
  ButtonStateProps,
  defaultButtonStyles,
} from './variants'

export type SecondaryButtonProperty = 'default' | 'inverted'

export interface SecondaryButtonProps
  extends ButtonProps,
    ButtonLayoutProps,
    LayoutProps,
    SpaceProps,
    ColorProps,
    TransitionProps,
    WhiteSpaceProps,
    FlexboxProps {
  variant?: ResponsiveStyleValue<SecondaryButtonProperty>
}

const defaultProps = withDefaultProps<SecondaryButtonProps>({
  variant: 'default',
  layout: 'default',
})

export const SecondaryButton = styled(Button)
  .attrs<ButtonStateProps>(buttonStateMapping)
  .attrs<SecondaryButtonProps>(defaultProps)(
  defaultButtonStyles,
  variant({
    scale: 'SecondaryButton.variants',
    variants: {
      default: {
        bg: 'secondaryAccent',
        color: 'chalk',
      },
      inverted: {
        bg: 'chalk',
        color: 'secondaryAccent',
      },
    },
  }),
  variant({
    prop: '$loadingState',
    scale: 'SecondaryButton.loading',
    variants: buttonLoadingVariants,
  }),
  variant({
    prop: '$disabledState',
    scale: 'SecondaryButton.disabled',
    variants: buttonDisabledVariants,
  }),
  buttonLayoutVariant,
  compose(layout, space, color, transition, whiteSpace, flexbox),
)
